/*
 * ANANDA Brand Story — per-word scroll-tied reveal.
 *
 * 1. Split each paragraph's text content into per-word <span> wrappers
 *    (preserves whitespace by joining with literal spaces).
 * 2. Create a single GSAP scrub timeline that tweens all word opacities
 *    from their CSS-defined 0.18 to 1, with a small stagger between
 *    consecutive words. ScrollTrigger ties the timeline progress to the
 *    section's position in the viewport.
 *
 * Round 3 (Roi feedback): end position pulled in from 'bottom 45%' to
 * 'top 30%'. The reveal now completes within ~65% of viewport height
 * of scrolling (was ~150% — too slow). User sees the words finish
 * brightening much earlier in the scroll arc.
 */
(function () {
  // Wait for GSAP to be ready via our scroll engine wrapper.
  function whenReady(cb) {
    if (window.AnandaScroll && window.AnandaScroll.gsap) {
      cb();
    } else {
      var tries = 0;
      var iv = setInterval(function () {
        if (window.AnandaScroll && window.AnandaScroll.gsap) {
          clearInterval(iv); cb();
        } else if (++tries > 50) {
          clearInterval(iv);
          console.warn('[brand-story] GSAP never arrived — falling back to static text.');
        }
      }, 50);
    }
  }

  function init() {
    var sections = document.querySelectorAll('[data-ananda-brand-story]');
    if (!sections.length) return;

    sections.forEach(function (section) {
      if (section.dataset.brandStoryInit === '1') return;
      section.dataset.brandStoryInit = '1';

      var textContainer = section.querySelector('[data-brand-story-text]');
      if (!textContainer) return;

      var paragraphs = textContainer.querySelectorAll('p');
      paragraphs.forEach(function (p) {
        var text = (p.textContent || '').trim();
        if (!text) return;
        var html = text.split(/\s+/).map(function (word) {
          return '<span class="ananda-brand-story__word">' + escapeHtml(word) + '</span>';
        }).join(' ');
        p.innerHTML = html;
      });

      var words = section.querySelectorAll('.ananda-brand-story__word');
      if (!words.length) return;

      var gsap = window.AnandaScroll.gsap;

      gsap.to(words, {
        opacity: 1,
        ease: 'none',
        stagger: 0.08,
        scrollTrigger: {
          trigger: section,
          start: 'top 95%',    // reveal begins almost as soon as section enters viewport
          end: 'top 30%',      // reveal completes when section top is 30% from viewport top —
                               // i.e. by the time the section is comfortably read-position.
                               // Much faster than the previous 'bottom 45%' (~65vh vs ~150vh).
          scrub: 0.3,
        },
      });
    });
  }

  function escapeHtml(s) {
    return s
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { whenReady(init); });
  } else {
    whenReady(init);
  }
})();
